import DisputeShopPickerPopup from './DisputeShopPickerPopupContainer'

export default DisputeShopPickerPopup
